:host {
  display: contents;
}

:host .tabs {
  color: var(--semantic-color-text-default);

  * {
    box-sizing: border-box;
  }

  .tab-header {
    position: relative;
    display: flex;
    width: 100%;

    .tab-list {
      display: inline-flex;
      min-width: 100%;

      .tab,
      .tab:focus,
      .tab:hover {
        all: unset;
        cursor: pointer;
        flex-grow: 1;
        padding: var-rem(--semantic-spacing-xs) calc(var-rem(--semantic-spacing-3xs) + wink-rem(0.1));
        text-transform: capitalize;
        white-space: nowrap;
        outline-offset: wink-rem(-0.3);

        &:first-of-type {
          padding-left: 0;
        }

        &:last-of-type {
          padding-right: 0;
        }

        .tab-content {
          display: flex;
          gap: var-rem(--semantic-spacing-md);
          align-items: center;
          height: 100%;
          padding: var-rem(--semantic-spacing-md) var-rem(--semantic-spacing-lg);
          border-radius: var-rem(--semantic-components-tab-radius-default-tab);
          font-size: var-rem(--semantic-typography-font-size-xs);
          background-color: var(--semantic-color-background-surface-bold-default);

          .tab-titles {
            display: flex;
            flex-direction: column;
            justify-content: center;
          }

          p {
            margin: 0;
          }

          .tab-title {
            font-family: var(--semantic-typography-font-family-primary), var(--font-fallbacks);
            font-size: var-rem(--semantic-typography-font-size-sm);
            font-weight: var(--semantic-typography-font-weight-regular);
            line-height: var-rem(--semantic-typography-line-height-desktop-body-md);
          }

          .tab-subtitle {
            line-height: var-rem(--semantic-typography-line-height-desktop-caption-md);
            color: var(--semantic-color-text-subtle);
          }
        }

        &:has(+ .is-active-tab) {
          padding-right: calc(var-rem(--semantic-spacing-xs) + wink-rem(0.2));
        }

        &.is-active-tab {
          position: relative;
          padding: calc(var-rem(--semantic-spacing-lg) + var-rem(--semantic-spacing-3xs)) var-rem(--semantic-spacing-lg)
            var-rem(--semantic-spacing-lg);
          border-top: var-rem(--semantic-border-lg) solid var(--semantic-components-tab-color-border-selected);
          border-radius: var-rem(--semantic-components-tab-radius-default-tab) var-rem(--semantic-components-tab-radius-default-tab) 0 0;
          background-color: var(--semantic-components-tab-color-background-default);

          @include media('from-sm') {
            padding: calc(var-rem(--semantic-spacing-lg) - var-rem(--semantic-spacing-3xs)) var-rem(--semantic-spacing-lg)
              var-rem(--semantic-spacing-lg);
          }

          .tab-content {
            padding: unset;
            background-color: unset;
          }

          + .tab {
            padding-left: calc(var-rem(--semantic-spacing-xs) + wink-rem(0.2));
          }
        }

        &:focus-visible {
          isolation: isolate;

          &:not(.is-active-tab) .tab-content {
            @include state-focus-outline;
          }

          &.is-active-tab {
            @include state-focus-outline;

            &:first-of-type {
              margin-left: var-rem(--semantic-spacing-3xs);
            }

            &:last-of-type {
              margin-right: var-rem(--semantic-spacing-3xs);
            }
          }
        }

        &:hover {
          .tab-content {
            border-radius: var-rem(--semantic-components-tab-radius-default-tab);
            background-color: var(--semantic-color-background-surface-bold-hovered);
          }

          &.is-active-tab .tab-content {
            background-color: unset;
          }
        }

        &:disabled {
          cursor: not-allowed;

          .tab-content {
            @include state-disabled;

            background-color: var(--semantic-color-background-surface-bold-default);
          }
        }
      }
    }

    &.is-scrollable {
      position: relative;
      z-index: 1;

      .tab-list {
        overflow: auto visible;
        margin-bottom: wink-rem(-0.6);
        padding: wink-rem(0.6) 0;

        @include hide-scrollbar;

        .tab {
          min-width: fit-content;
        }
      }
    }

    .scroll-button {
      position: absolute;
      top: 0;
      bottom: 0;
      height: fit-content;
      margin: auto 0;

      &-left {
        left: var-rem(--semantic-spacing-xs);
      }

      &-right {
        right: var-rem(--semantic-spacing-xs);
      }
    }
  }

  [role='tabpanel'] {
    overflow: auto;
    width: 100%;
    padding: var-rem(--semantic-spacing-xl);
    border-radius: 0 0 var-rem(--semantic-components-tab-radius-default-tab) var-rem(--semantic-components-tab-radius-default-tab);
    background-color: var(--semantic-components-tab-color-background-default);

    * {
      font-size: 1.6rem;
    }

    &.is-hidden {
      display: none;
    }

    &:focus-visible {
      @include state-focus-outline;

      outline-offset: wink-rem(-0.2);
    }
  }

  &-inline {
    [role='tabpanel'] {
      padding: var-rem(--semantic-spacing-lg);
      background-color: var(--semantic-color-background-canvas-default);
    }

    .tab-header .tab-list {
      .tab,
      .tab:focus,
      .tab:hover {
        border-bottom: var-rem(--semantic-border-sm) solid var(--semantic-color-border-default);

        .tab-content {
          padding: var-rem(--semantic-spacing-xs) var-rem(--semantic-spacing-lg);
        }

        &.is-active-tab {
          padding: var-rem(--semantic-spacing-horizontal-default) var-rem(--semantic-spacing-lg);
          border: var-rem(--semantic-border-sm) solid var(--semantic-color-border-default);
          border-top: var-rem(--semantic-border-lg) solid var(--semantic-color-border-selected);
          border-bottom: var-rem(--semantic-border-sm) solid var(--semantic-color-background-canvas-default);
          background-color: var(--semantic-color-background-canvas-default);
        }
      }
    }
  }
}
